import { Injectable,  } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Headers, Http, Response, RequestOptions } from '@angular/http';
import { AuthHttp } from 'angular2-jwt';
import { ConstantService } from "../utils/constant.service";

@Injectable()
export class NavigationService {
    private url="login"
    constructor(public authHttp: AuthHttp) {
         let constantService = new ConstantService();  
         this.url = constantService.API_ENDPOINT + this.url;
     }

    prueba(): Observable<string> {
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.get(this.url + "/status").map(this.extractData)
            .catch(this.handleError);
    }
    private extractData(res: Response) {
        let body = res.json();
        return body || {};
    }
    private handleError(error: any) {
        return Observable.throw(error);
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/components/common/navigation/navigation.service.ts